import { render } from "./ManageCarFleet.vue?vue&type=template&id=0a3542d2&scoped=true"
import script from "./ManageCarFleet.vue?vue&type=script&lang=js"
export * from "./ManageCarFleet.vue?vue&type=script&lang=js"

import "./ManageCarFleet.vue?vue&type=style&index=0&id=0a3542d2&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3542d2"]])

export default __exports__